import missingData from "../tools/missingData";

const calcSedComplete = (data) => {
  // incomplete is an array of fields that are undefined or have a length < 1

  let dataArray = Object.entries(data)
    let incomplete = dataArray.filter(missingData)

    // console.log(incomplete, 'incomplete')
      
    if (incomplete.length > 0){
      data.complete = 100 - (incomplete.length / dataArray.length * 100)
      // console.log(data.complete, 'completeness')
    } else {
      data.complete = 100
      // console.log(data.complete, 'completeness')
    }
    return data
}

export default calcSedComplete